import Swal from "sweetalert2";
import { IEmpresas } from "../interfaces/IEmpresas";
import api from "./Api";

class ImportarService {

  async enviarArquivoObrigacaoAcessoria(esteira: number, urlArquivo: string, nomeArquivo: string, textoPopupSucesso?: string): Promise<boolean> {
    try {
      await api.post(`ObrigacaoAcessoria/Importar/${esteira}`, {
        urlArquivo,
        nomeArquivo
      });

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async estornarLancamento(id: number): Promise<boolean> {
    try {
      await api.post(`Esteira/EstornarConta/${id}`);
      Swal.fire({
        text: 'Estorno feito com sucesso.',
        timer: 4000,
        icon: 'success',
        showConfirmButton: false
      });
      return true;
    } catch (error: any) {
      Swal.fire({
        text: 'Ocorreu um erro ao estornar a conta.',
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async enviarArquivoExtrato(esteira: number, conta: number, urlArquivo: string, nomeArquivo: string, textoPopupSucesso?: string): Promise<boolean> {
    try {
      await api.post(`BancoCaixaImportacao/importar/${esteira}/${conta}`, {
        urlArquivo,
        nomeArquivo
      }, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async validaEcd(urlArquivo: string, nomeArquivo: string): Promise<boolean> {
    const { data: result } = await api.post<boolean>('Importacao/valida-ecd', {
      urlArquivo,
      nomeArquivo
    });

    return result;
  }

  async criarEsteira(obj: any, regimeTributario: string): Promise<IEmpresas> {
    try {
      const { data: result } = await api.post<IEmpresas>(`Importacao/cadastro-esteira/${regimeTributario}`, { ...obj }, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });
      return result;
    } catch (error: any) {
      Swal.fire({
        text: error.message || 'Ocorreu um erro ao cadastrar a empresa',
        timer: 3000,
        icon: 'error',
        showConfirmButton: false
      });
      return {} as IEmpresas;
    }
  }

  async configurarContaContabil(esteiraID: number, conta: string, referencial: string): Promise<any> {
    const { data: result } = await api.put(`razao/CriarPlanoConta/${esteiraID}/${conta}/${referencial}`, null, {
      baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
    });

    return result;
  }

  async uploadRazao(body: FormData, tipo: string, esteiraID: number, lines: number, empresaID: any, dataInicial?: string, dataFinal?: string): Promise<IEmpresas> {
    try {
      if (empresaID && empresaID > 0 && dataInicial && dataFinal) {

        const dataIArr = dataInicial.split('/');
        const dataFArr = dataFinal.split('/');

        const dtI = `${dataIArr[2]}-${dataIArr[1]}-${dataIArr[0]}`;
        const dtF = `${dataFArr[2]}-${dataFArr[1]}-${dataFArr[0]}`;

        const { data: result } = await api.post(`razao/${tipo}?empresaID=${empresaID}&dataInicial=${dtI}&dataFinal=${dtF}`, body, {
          baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/',
          headers: { "Content-Type": "multipart/form-data" }
        });

        return result;
      } else {
        const { data: result } = await api.post(`razao/${tipo}`, body, {
          baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/',
          headers: { "Content-Type": "multipart/form-data" }
        });

        return result;
      }
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 3000,
        icon: 'error',
        showConfirmButton: false
      });
      return {} as IEmpresas;
    }
  }

  async upload(body: FormData, esteiraID: number, lines: number, plano: string): Promise<IEmpresas> {
    try {
      const { data: result } = await api.post(`ecd/${plano}`, body, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/',
        headers: { "Content-Type": "multipart/form-data" }
      });

      return result;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 3000,
        icon: 'error',
        showConfirmButton: false
      });
      return {} as IEmpresas;
    }
  }

  async enviarArquivo(regime: string, urlArquivo: string, nomeArquivo: string, funcaoSucesso?: (data: IEmpresas) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.post<IEmpresas>(`Importacao/ecd/${regime}`, {
        urlArquivo,
        nomeArquivo
      });

      await api.post(`Importacao/Processar/${result.esteiraImportando || 0}`, null, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/'
      });

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
      return false;
    }
  }

  async enviarPosicaoFinanceira(empresaID: number, url: string, tipo: string): Promise<void> {
    try {
      await api.post('Importacao/posicao-financeira/' + empresaID, { url, tipo });
      Swal.fire({
        text: 'Arquivo foi enviado para processamento, assim que concluido será retornado em seu e-mail.',
        timer: 4000,
        icon: 'success',
        showConfirmButton: false
      });
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });
    }
  }

  async getBancosContas(esteiraID: number, funcaoSucesso?: (data: any[]) => void): Promise<boolean> {
    try {
      const { data: result } = await api.get<any[]>(`Importacao/bancos-contas/${esteiraID}`);
      funcaoSucesso && funcaoSucesso(result);
      return true;
    } catch (error: any) {
      return false;
    }
  }

  async sendInitialFile(body: FormData): Promise<IEmpresas> {
    try {
      const { data: result } = await api.post(`InitialFile`, body, {
        baseURL: process.env.REACT_APP_API_URL ?? 'https://desenvolvimento.painel-agholmes-1.com.br/api/',
        headers: { "Content-Type": "multipart/form-data" }
      });

      return result;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 3000,
        icon: 'error',
        showConfirmButton: false
      });
      return {} as IEmpresas;
    }
  }
}


export default new ImportarService();